<template>
  <div class="footer">
    <div class="fixed-join-num">
      <img class="fixed-join-icon" src="@/assets/images/join.png" alt="" />
      <div class="">
        <div>招商及加盟热线</div>
        <div style="font-size:22px;font-weight:600">
          {{ contactData.join_hotline }}
        </div>
      </div>
    </div>

    <div class="box">
      <div class="header-content">
        <div class="logo-box">
          <img class="logo" src="@/assets/images/logo_white.png" />
          <p>专业立身 创新驱动 合作共赢</p>
        </div>
        <div class="navigation-box">
          <div class="select">
            <div
              v-for="(item, index) in titleList"
              :key="index"
              @click="onselect(item)"
            >
              {{ item.navigation_title }}
            </div>
          </div>
          <div class="contact">
            <div class="address">
              <img
                src="@/assets/images/index/bottom_address.png"
                alt=""
                srcset=""
              />联系地址 : {{ contactData.company_address }}
            </div>
            <div class="address">
              <img
                src="@/assets/images/index/bottom_phone.png"
                alt=""
                srcset=""
              />投诉及事故报警： {{ contactData.complaint_hotline }}
            </div>
          </div>
        </div>
      </div>
      <div class="subsidiary-wrap">
        <div class="subsidiary">
          <p v-for="(item, index) in subsidiaries" :key="index">{{ item }}</p>
        </div>
        <div class="er-code-wrap">
          <img
            class="er-code"
            src="@/assets/images/index/er_code.jpg"
            alt=""
            srcset=""
          />
          <p>（沃沃农贸公众号二维码）</p>
        </div>
      </div>
    </div>
    <div class="copy">
      <div class="copyer">
        <p class="copy-p">
          Copyright 2021-2025 All Rights Reserved
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >京ICP备2021022731号</a
          >
        </p>
        <p class="copy-p">
          增值电信业务经营许可证（ICP、EDI）:
          <a target="_blank" href="https://beian.miit.gov.cn/">京B2-20221454</a>
        </p>
        <p class="copy-p">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009799&amp;no_protofix"
          >
            <img class="beian" src="@/assets/images/index/beian.png" />
          </a>
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009799&amp;no_protofix"
            >京公网安备 11010202009799号</a
          >
          <span>北京沃沃智慧农贸集团有限公司</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      titleList: [
        {
          link_addr: "index",
          navigation_title: "首页"
        },
        {
          link_addr: "company-profile",
          navigation_title: "关于沃沃"
        },
        {
          link_addr: "solution",
          navigation_title: "解决方案"
        },
        {
          link_addr: "news",
          navigation_title: "新闻中心"
        },
        {
          link_addr: "products",
          navigation_title: "产品服务"
        },
        {
          link_addr: "successful-cases",
          navigation_title: "经典案例"
        },
        {
          link_addr: "application",
          navigation_title: "平台登录"
        },
        {
          link_addr: "contact-us",
          navigation_title: "联系我们"
        },
        {
          link_addr: "supply-chain",
          navigation_title: "供应链"
        },
        {
          link_addr: "social-responsibility",
          navigation_title: "社会责任"
        },
        {
          link_addr: "recruit",
          navigation_title: "人才招聘"
        }
      ]
    };
  },

  mounted() {
    this.getContactData();
    this.getSubsidiaries();
  },
  methods: {
    ...mapActions(["getContactData", "getSubsidiaries"]),
    onselect(item) {
      if (item.link_addr != "login") {
        this.$router.push({
          name: item.link_addr
        });
      }
    }
  },
  computed: {
    ...mapGetters(["contactData", "subsidiaries"])
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  background: #2d3d5d;
  margin-top: 20px;
}
.box {
  background: url("../assets/images/base.png") no-repeat center;
  background-size: cover;
}
.header-content {
  width: 1240px;
  height: 170px;
  display: flex;
  align-items: center;
  margin: 0px auto;
  padding-top: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.logo-box {
  width: 300px;
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  position: relative;
  margin-right: 30px;
}
.logo-box .logo {
  width: 200px;
  height: 60px;
  margin-bottom: 10px;
}
.logo-box::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -24px;
  width: 2px;
  height: 48px;
  background-color: rgba(204, 204, 204, 0.6);
  border-radius: 1px;
}
.navigation-box {
  flex: 1;
}
.select {
  width: 100%;
  height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  cursor: pointer;
}
.contact {
  display: flex;
  width: 100%;
  height: 30px;
  margin-top: 30px;
  color: #dcdcdc;
  align-items: center;
  line-height: 30px;
  justify-content: space-between;
}
.contact img {
  vertical-align: middle;
  margin-right: 6px;
}

.subsidiary-wrap {
  width: 1240px;
  padding-bottom: 40px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;
}
.er-code-wrap {
  margin-top: 10px;
}
.er-code-wrap p {
  font-size: 18px;
  color: #fff;
  margin-top: 10px;
}
.er-code {
  width: 230px;
  height: 230px;
}

.subsidiary {
  width: 920px;
  color: #ccc;
  display: flex;
  font-size: 16px;
  line-height: 40px;
  flex-wrap: wrap;
}
.subsidiary p {
  width: 33%;
}
/* .subsidiary p:nth-of-type(4n) {
  width: 33%;
}
.subsidiary p:nth-of-type(4n-1) {
  width: 33%;
} */
.copy {
  width: 100%;
  background: #1f2127;
  padding: 30px 0;
}
.copyer {
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #dcdcdc;
  line-height: 1.8;
}
.copy-p span {
  margin-left: 10px;
}
.copy-p a {
  color: #dcdcdc;
}
.copy-p a:hover {
  text-decoration: underline;
}
.beian {
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
}

.fixed-join-num {
  position: fixed;
  right: 0;
  top: 48%;
  width: 280px;
  height: 80px;
  background: #1de2ac;
  border-radius: 50px 0px 0px 50px;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  color: #fff;
  z-index: 1000;
  font-weight: 600;
}
.fixed-join-icon {
  margin-right: 8px;
}
.test {
}
</style>



// WEBPACK FOOTER //
// src/components/CommonBottom.vue